import { render, staticRenderFns } from "./GalleryManageHotelAdd.vue?vue&type=template&id=1cab1d4c"
import script from "./GalleryManageHotelAdd.vue?vue&type=script&lang=js"
export * from "./GalleryManageHotelAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports